import { apiCall, apiCallAdmin } from "../../services/api-service.js";

export const getLocationApi = async (term) => {
  const response = await apiCallAdmin("GET", `get_location?term=${term}`);
  return response;
};

export const getVehicleTypeApi = async (term) => {
  const response = await apiCall("GET", `vehicletype/autosuggestion?term=${term}`);
  return response;
};

export const getDockApi = async (term) => {
  const response = await apiCall("GET", `dockmaster/autosuggestion?term=${term}`);
  return response;
};

export const getStatusApi = async (term) => {
  const response = await apiCallAdmin("GET", `get_location?term=${term}`);
  return response;
};

export const exportdata = async (data) => {
  const response = await apiCall("POST", "dock/report", data);
  return response;
};

export const downloadBase64File = (base64String, fileName) => {
  const binary = atob(base64String);
  const array = [];

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportquickApi = async (
  apivalue,
  formattedFromDate,
  formattedToDate
) => {
  const response = await apiCall("POST", `report/${apivalue}`, {
    from_date: formattedFromDate,
    to_date: formattedToDate,
  });
  return response;
};

export const getquickreportApi = async () => {
  const response = await apiCall("GET", "report/get_quick_report");
  return response.data;
};

// templates & exports

export const savetempalteApi = async (data) => {
  const response = await apiCallAdmin("POST", "export_template", data);
  return response;
};

export const getExportfieldApis = async (id) => {
  const response = await apiCallAdmin("GET", `export_template/${id}`);
  return response.data;
};

export const getDownloadReportApi = async () => {
  const response = await apiCallAdmin("GET", "downloaded_reports?type=Dock");
  return response.data;
};

export const getExportdownloadApis = async (id) => {
  const response = await apiCallAdmin("GET", `downloaded_reports/${id}`);
  return response.data;
};

export const getTempalteApi = async () => {
  const response = await apiCallAdmin("GET", "export_template?application=Dock");
  return response.data;
};
